import styled from 'styled-components';

import { basicBodyTextStyle } from '@dreryk/react-components';

export const APPOINTMENTS_FILTER_CHIPS_LABEL_CLASS_NAME = 'appointmentsFilterChipsLabel';

export const StyledAppointmentsFilterChips = styled.div`
   ${basicBodyTextStyle};
   padding: 8px 0 24px 0;
   display: inline-flex;
   align-items: center;
   gap: 8px;
   flex-wrap: wrap;

   &:not(:has(:not(.${APPOINTMENTS_FILTER_CHIPS_LABEL_CLASS_NAME}))) .${APPOINTMENTS_FILTER_CHIPS_LABEL_CLASS_NAME} {
      display: none;
   }
`;

StyledAppointmentsFilterChips.displayName = 'StyledAppointmentsFilterChips';
